import { createTheme } from '@mui/material/styles'
import { deepmerge } from '@mui/utils'

let theme = createTheme()

// CHOICES:
const palette = {
  limeGreen: '#8dc63f',
  rightNowRed: '#be1e2d',
  wrongRed: '#F44336',
  helloYellow: '#f8c440',
  black: '#000',
  white: '#fff',
  // kid world:
  popPurple: '#652d90',
  stopmeFuschia: '#be02c2',
  bandstandOrange: '#f15a24',
  orangeCrush: '#f7931e'
}

const fontFamily = {
  main: ['brandon-grotesque', 'sans-serif'].join(', ')
}

// DECISIONS:
theme = createTheme({
  typography: {
    fontFamily: fontFamily.main
  },
  breakpoints: {
    // material-ui defaults:
    // xs, extra-small: 0px
    // sm, small: 600px
    // md, medium: 900px
    // lg, large: 1200px
    // xl, extra-large: 1536px
  },
  palette: {
    // color intentions:
    primary: {
      main: palette.black,
      contrastText: palette.white
    },
    secondary: {
      main: palette.limeGreen,
      contrastText: palette.white
    },
    success: {
      main: palette.limeGreen,
      contrastText: palette.white
    },
    info: {
      main: '#e0e0e0'
    },
    warning: {
      main: palette.helloYellow
    },
    error: {
      main: palette.wrongRed
    },
    background: {
      default: '#fafafa'
    }
  }
})

theme = createTheme(theme, {
  typography: {
    // fontSize: '0.875rem',
    // fontFamily: fontFamily.main,
    h1: {
      marginTop: 0,
      marginBottom: '.6rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '26px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '32px',
        lineHeight: 1.125
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '41px',
        lineHeight: 1.125
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '46px',
        lineHeight: 1.125
      }
    },
    h2: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '26px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '28px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '32px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '36px',
        lineHeight: 1.125
      }
    },
    h3: {
      [theme.breakpoints.down('md')]: {
        fontSize: '20px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '22px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '26px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '28px',
        lineHeight: 1.125
      }
    },
    h4: {
      [theme.breakpoints.down('md')]: {
        fontSize: '18px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '20px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '22px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '26px',
        lineHeight: 1.125
      }
    },
    h5: {
      [theme.breakpoints.down('md')]: {
        fontSize: '16px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '18px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '20px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '22px',
        lineHeight: 1.125
      }
    },
    h6: {
      [theme.breakpoints.down('md')]: {
        fontSize: '12px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '12px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '14px',
        lineHeight: 1.25
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '14px',
        lineHeight: 1.125
      }
    },
    subtitle1: {},
    subtitle2: {},
    body1: {
      // uno/variables/typography.scss
      [theme.breakpoints.down('lg')]: {
        fontSize: '18px',
        lineHeight: 1.3
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '20px',
        lineHeight: 1.3
      }
    },
    body2: {},
    button: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px'
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '20px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '22px'
      }
    },
    caption: {},
    overline: {}
  },
  shape: {
    borderRadius: 0
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          lineHeight: 1.3
        },
        filledSuccess: {
          color: 'white'
        }
      }
    },
    AccountButton: {
      fontStyle: 'italic'
    },
    DesktopHeader: {
      Box: {
        bgcolor: theme.palette.common.black
      },
      Typography: {
        color: theme.palette.common.white
      }
    },
    AccountFooter: {
      Box: {
        bgcolor: palette.black,
        color: theme.palette.common.white
      }
    }
  }
})

export default theme
